export default __webpack_public_path__ + "static/media/Home-foto-header-sports-Tower-viajes-mobile@2x.0c3c7288.jpg";